import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e2a7a08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crud-page-title d-flex mb-3" }

import { useStore } from "vuex";
import CrudTable from "@/components/tables/CrudTable.vue";
import BasicContentWrapper from "@/components/spacing/BasicContentWrapper.vue";
import { computed, ref, watch } from "vue";
import { accessStoreKey } from "@/helpers/dto";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCrudView',
  props: {
  headerLabels: {
    type: Array,
    required: true,
  },
  navBarTab: {
    type: Number,
    default: null,
  },
  actionText: {
    type: String,
    required: true,
  },
  hasApiFilters: {
    type: Boolean,
    default: false,
  },
  stateFilters: {
    type: Array,
    default: () => [],
  },
  hideSearch: {
    type: Boolean,
    default: false,
  },
  showDateRangeFilter: {
    type: Boolean,
    default: false,
  },
  storeDataKey: {
    type: [String, Array],
    required: true,
  },
  getDataKey: {
    type: String,
    required: true,
  },
  deleteDataKey: {
    type: String,
    required: true,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  actionRoutes: {
    type: Object,
    required: true,
  },
  filters: {
    type: Array,
    required: false,
    default: () => [],
  },
  searchFilter: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();



// const currentRoute = useRoute();
// const paramId = computed(() => currentRoute.params.id || "");
const filtersUsers = ref({});

const pageExtraTitle = computed(() => store.state.page.pageExtraTitle);
const data = computed(() => accessStoreKey(store.state, props.storeDataKey));
const apiPagination = computed(() => data.value.apiPagination);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasicContentWrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(pageExtraTitle.value), 1),
      _createVNode(CrudTable, {
        modelValue: filtersUsers.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtersUsers).value = $event)),
        "hide-search": __props.hideSearch,
        "action-text": __props.actionText,
        "show-date-range-filter": __props.showDateRangeFilter,
        "has-api-filters": __props.hasApiFilters,
        data: data.value.data,
        columns: __props.columns,
        filters: __props.filters,
        "state-filters": __props.stateFilters,
        "search-filter": __props.searchFilter,
        "action-routes": __props.actionRoutes,
        "get-data-key": __props.getDataKey,
        "delete-data-key": __props.deleteDataKey,
        "api-pagination": apiPagination.value,
        selectable: ""
      }, null, 8, ["modelValue", "hide-search", "action-text", "show-date-range-filter", "has-api-filters", "data", "columns", "filters", "state-filters", "search-filter", "action-routes", "get-data-key", "delete-data-key", "api-pagination"])
    ]),
    _: 1
  }))
}
}

})